import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import AfricaLoudHome from "./pages/AfricaLoudHome";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import AfricaLoudSuite from "./pages/AfricaLoudSuite";
import Terms from "./pages/Terms";
import Collab from "./pages/Collab";
import AfricanFilmAtlas from "./pages/AfricanFilmAtlas";
import Echoes from "./pages/Echoes";
import About from "./pages/About";
import Signup from "./pages/Signup";

// All articles live in /pages/articles
import BtsAfrobeatsAmapiano from "./pages/articles/BtsAfrobeatsAmapiano";
import AfricanSubcultures from "./pages/articles/AfricanSubcultures";
import BeyonceGenresGlobalScene from "./pages/articles/BeyonceGenresGlobalScene";
import AfrobeatVsAfrobeats from "./pages/articles/AfrobeatVsAfrobeats";
import TownTalk from "./pages/articles/TownTalk";
import RiseOfTyla from "./pages/articles/RiseOfTyla";
import LanguageAsHistory from "./pages/articles/LanguageAsHistory";
import IsTylaAfrobeats from "./pages/articles/IsTylaAfrobeats";
import AfricanFashionRenaissance from "./pages/articles/AfricanFashionRenaissance";
import Amapiano from "./pages/articles/Amapiano";
import ChristopherEmefiele from "./pages/articles/ChristopherEmefiele";
import InvestInRwanda from "./pages/articles/InvestInRwanda";
import NuuOldestLanguage from "./pages/articles/NuuOldestLanguage";
import TealEditArticle from "./pages/articles/TealEditArticle";

function App() {
  const [user, setUser] = useState(null);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<AfricaLoudHome />} />

        <Route path="/login" element={<Login user={user} onLogin={setUser} />} />

        <Route
          path="/dashboard"
          element={
            user ? (
              <Dashboard currentUser={user} />
            ) : (
              <Navigate to="/login" replace />
            )
          }
        />

        <Route path="/ams" element={<AfricaLoudSuite />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/collab" element={<Collab />} />
        <Route path="/film" element={<AfricanFilmAtlas />} />
        <Route path="/echoes" element={<Echoes />} />
	<Route path="/about" element={<About />} />
	<Route path="/signup" element={<Signup user={user} />} />

        <Route
          path="/culture-music/from-k-pop-to-afrobeats-amapiano"
          element={<BtsAfrobeatsAmapiano />}
        />
        <Route
          path="/culture-music/african-subcultures"
          element={<AfricanSubcultures />}
        />
        <Route
          path="/culture-music/beyonce-genres-global-scene"
          element={<BeyonceGenresGlobalScene />}
        />
        <Route
          path="/culture-music/afrobeat-vs-afrobeats"
          element={<AfrobeatVsAfrobeats />}
        />
        <Route path="/culture-music/town-talk" element={<TownTalk />} />
        <Route path="/culture-music/the-rise-of-tyla" element={<RiseOfTyla />} />
        <Route
          path="/culture-music/language-as-history"
          element={<LanguageAsHistory />}
        />
        <Route
          path="/culture-music/is-tyla-afrobeats"
          element={<IsTylaAfrobeats />}
        />
        <Route path="/culture-music/amapiano" element={<Amapiano />} />
        <Route
          path="/culture-music/invest-in-rwanda"
          element={<InvestInRwanda />}
        />

 	<Route
  path="/culture-music/nuuoldestlanguage"
  element={<NuuOldestLanguage />}
/>

        <Route
          path="/art-fashion/african-fashion-renaissance"
          element={<AfricanFashionRenaissance />}
        />
        <Route
          path="/art-fashion/christopher-emefiele-cultural-fusion"
          element={<ChristopherEmefiele />}
        />
<Route path="/art-fashion/africa-in-bloom-teal-edit" element={<TealEditArticle />} />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;